import { RefObject, useEffect, useMemo, useState } from 'react';
import { RecaptchaSize } from '../types/recaptcha-size';

interface useRecaptchaSizeResponse {
  width: number;
  height: number;
  scale: number;
}

export const useRecaptchaSize = (wrapperRef: RefObject<HTMLDivElement>): useRecaptchaSizeResponse => {
  const [scale, setScale] = useState(0);
  const width = useMemo(() => RecaptchaSize.DefaultWidthInPx * scale, [scale]);
  const height = useMemo(() => RecaptchaSize.DefaultHeightInPx * scale, [scale]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const { width } = entries[0].contentRect;

      if (width < RecaptchaSize.DefaultWidthInPx) {
        setScale(width / RecaptchaSize.DefaultWidthInPx);
        return;
      }

      setScale(1);
    });

    resizeObserver.observe(wrapperRef.current?.parentNode as Element);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return {
    width,
    height,
    scale,
  };
};
